import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import {
  NotificationContentBase,
  NotificationItemBaseProps,
} from "../../types/notification.types";
import { ComponentNotificationTaskType } from "./types/task-notification.types";
import styles from "./task-notification.module.css";
import { TaskNotificationTitle } from "./TaskNotificationTitle";
import { TaskNotificationBody } from "./TaskNotificationBody";
import { TaskNotificationFooter } from "./TaskNotificationFooter";

interface NotificationTaskNotificationFactoryProps extends NotificationItemBaseProps {
  content: NotificationContentBase;
}

export const NotificationTaskNotificationFactory = ({
  content,
  onClick,
  read,
  createdAt,
}: NotificationTaskNotificationFactoryProps) => {
  const { components, props } = content as ComponentNotificationTaskType;
  const navigateUrl = `tasks?taskDetails=${props.taskId}`;
  const [title, body, footer] = components;
  return (
    <div
      className={styles["task-notification-item"] ?? ""}
      onClick={() => onClick()}
    >
      <FixaLink to={navigateUrl}>
        <TaskNotificationTitle component={title} read={read} />
        <TaskNotificationBody component={body} read={read} />
        <TaskNotificationFooter component={footer} createdAt={createdAt} />
      </FixaLink>
    </div>
  );
};
